//
// toast.js
// Theme module
//

( function($, waTheme) {

    var Dialog = (function ($) {

        "use strict";

        Dialog = function (options) {
            var that = this;

            // LOAD
            that.html = (options['html'] || false);
            that.$body = $("body");

            // INIT
            that.initDialog();

            // DOM
            that.$dialog = $("#s-dialog-wrapper");

            return that;
        };

        Dialog.prototype.initDialog = function () {
            var that = this;

            that.showDialog();

            that.bindEvents();
        };

        Dialog.prototype.bindEvents = function () {
            var that = this;

            $('#s-dialog-wrapper').on('hidden.bs.modal', function() {
                $('#s-dialog-wrapper').remove();
            });
        };

        Dialog.prototype.showDialog = function () {
            var that = this;

            let $dialog = `              
                <div class="modal fade" id="s-dialog-wrapper" tabindex="-1">
                  <div class="modal-dialog modal-dialog-centered modal-xl modal-fullscreen-xl-down">
                    <div class="modal-content">
                      <div class="modal-body">
                        <button type="button" class="position-absolute top-0 end-0 btn-close" data-bs-dismiss="modal" aria-label="Close" style="width: 3rem;
    height: 2.5rem;"></button>
                        ${that.html}
                      </div>
                    </div>
                  </div>
                </div>
            `;

            that.$body.append($dialog);

            $('#s-dialog-wrapper').modal("show");

        };

        return Dialog;

    })($);

    waTheme.init.site.Dialog = Dialog;

})(jQuery, window.waTheme);